module.exports = __webpack_public_path__ + "img/lee-and-kathleen.1c1105b0.jpg";